/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Container, Grid, Stack, CircularProgress, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
// eslint-disable-next-line import/no-unresolved
import Actionbutton from 'src/components/Actionbutton'
// eslint-disable-next-line arrow-body-style
import { useNavigate, useParams } from 'react-router-dom';
import Papa from "papaparse";
import dayjs from 'dayjs';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import AddLoan from './Add'
import EditModel from './Edit'
import DeleteModel from '../../components/Deletemodle'
import Header from '../../components/Header';
import LoanActivityTimeline from './timeline/LoanActivityTimeline';
import Overview from './Overview';
import Efolder from './Efolder';
import Other from './Other';
import DocuSignPage from './Docusign';
import RequestDocuments from './DocumentRequest';
// eslint-disable-next-line arrow-body-style
import { apidelete, apiget, apipost } from '../../service/api';
// eslint-disable-next-line no-unused-vars
import { CustomTabPanel, a11yProps } from '../../components/CustomTabPanel';

const View = () => {
    const [loanData, setLoanData] = useState({});
    const [efolderData, setEfolderData] = useState([]);
    const [userAction, setUserAction] = useState(null);
    const [openAdd, setOpenAdd] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [opendelete, setOpendelete] = useState(false);
    const [value, setValue] = useState(0);
    const [loading, setLoading] = useState(false);
    const userid = localStorage.getItem('user_id');
    const params = useParams();
    const navigate = useNavigate();

    // open add model
    const handleOpenAdd = () => setOpenAdd(true);
    const handleCloseAdd = () => setOpenAdd(false);

    // open edit model
    const handleOpenEdit = () => setOpenEdit(true);
    const handleCloseEdit = () => setOpenEdit(false);

    // open delete model
    const handleOpenDelete = () => setOpendelete(true);
    const handleCloseDelete = () => setOpendelete(false);

    // tab
    const handleChange = (event, newValue) => setValue(newValue);

    const back = () => {
        navigate('/dashboard/loan');
    }

    // fetch api
    const fetchdata = async () => {
        setLoading(true);
        try {
            const result = await apipost(`loan/info/${params.id}`, { userid });
            if (result && result.status === 200) {
                console.log("Successful API response for fetch data. Data:", result.data);
                const loanData = result.data.result;
                setLoanData(loanData);
                fetchEfolderData();
            }
        } finally {
            setLoading(false);
        }
    };

    // fetch efolder data
    const fetchEfolderData = async () => {
        try {
            const result = await apiget(`loan/efolder/${params.id}`,  { userid } );
            if (result && result.status === 200) {
                setEfolderData(result.data.result);
            }
        } catch (error) {
            console.error('Error fetching efolder data:', error);
        }
    };


    // delete api
    const deletedata = async () => {
        await apidelete(`loan/delete/${params.id}`);
        navigate('/dashboard/loan');
    };

    useEffect(() => {
        fetchdata();
    }, [userAction]);

    // Export data in csv file
    const loanCsvData = [
        {
            title: loanData?.title,
            firstName: loanData?.firstName,
            lastName: loanData?.lastName,
            dateOfBirth: dayjs(loanData?.dateOfBirth).format('DD-MM-YYYY'),
            gender: loanData?.gender,
            phoneNumber: loanData?.phoneNumber,
            emailAddress: loanData?.emailAddress,
            address: loanData?.address,
            loanSource: loanData?.loanSource,
            loanStatus: loanData?.loanStatus,
            loanScore: loanData?.loanScore,
            alternatePhoneNumber: loanData?.alternatePhoneNumber,
            additionalEmailAddress: loanData?.additionalEmailAddress,
            instagramProfile: loanData?.instagramProfile,
            twitterProfile: loanData?.twitterProfile,
            typeOfInsurance: loanData?.typeOfInsurance,
            desiredCoverageAmount: loanData?.desiredCoverageAmount,
            specificPolicyFeatures: loanData?.specificPolicyFeatures,
            QualificationStatus: loanData?.QualificationStatus,
            policyType: loanData?.policyType,
            policyNumber: loanData?.policyNumber,
            startDate: dayjs(loanData?.startDate).format('DD-MM-YYYY'),
            endDate: dayjs(loanData?.endDate).format('DD-MM-YYYY'),
            coverageAmount: loanData?.coverageAmount,
            termLength: loanData?.termLength,
            conversionReason: loanData?.conversionReason,
            conversionDateTime: loanData?.conversionDateTime,
            loanCategory: loanData?.loanCategory,
            loanPriority: loanData?.loanPriority,
            assigned_agent: `${loanData?.assigned_agent?.firstName} ${loanData?.assigned_agent?.firstName}`,
            createdOn: dayjs(loanData?.createdOn).format('DD-MM-YYYY HH:mm:ss'),
            modifiedOn: dayjs(loanData?.modifiedOn).format('DD-MM-YYYY HH:mm:ss'),
        },
    ];

    const handleExport = () => {
        const csvString = Papa.unparse(loanCsvData);
        const csvBlob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const csvUrl = URL.createObjectURL(csvBlob);
        const downloadLink = document.createElement("a");

        downloadLink.href = csvUrl;
        downloadLink.setAttribute(
            "download",
            `Loan_Data`
        );
        downloadLink.click();
    };

    return (
        <div>
            {/* Add Loan Model */}
            <AddLoan open={openAdd} handleClose={handleCloseAdd} />

            {/* Add Edit Model */}
            <EditModel open={openEdit} handleClose={handleCloseEdit} id={params.id} fetchLoan={fetchdata} />

            {/* open Delete Model */}
            <DeleteModel opendelete={opendelete} handleClosedelete={handleCloseDelete} deletedata={deletedata} id={params.id} />

            <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3 } }}>
                <Grid container display="flex" alignItems="center">
                    <Stack direction="row" alignItems="center" mb={2} justifyContent={"space-between"} width={"100%"}>
                        <Header
                            title={`${loanData?.['4000'] || ''} ${loanData?.['4002'] || ''}`}
                            subtitle={`Loan #  ${loanData?.["364"] || ''}`}
                        />
                        <Stack direction="row" alignItems="center" justifyContent={"flex-end"} spacing={2}>
                            <Actionbutton
                                handleOpen={handleOpenAdd}
                                handleOpenEdit={handleOpenEdit}
                                handleOpenDelete={handleOpenDelete}
                                handleExport={handleExport}
                                back={back}
                            />
                        </Stack>
                    </Stack>
                </Grid>

                {/* Split-screen layout */}
                <Grid container spacing={2} sx={{ minHeight: 'calc(100vh - 180px)' }}>
                    {/* Left Panel - Loan Content */}
                    <Grid item xs={12} md={7}>
                        <Box sx={{ width: '100%' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 0 }}>
                                <Tabs value={value} onChange={handleChange} aria-label="loan tabs">
                                    <Tab label="Loan Summary" {...a11yProps(0)} />
                                    <Tab label="Efolder" {...a11yProps(1)} />
                                    <Tab label="OTHER" {...a11yProps(2)} />
                                    <Tab label="Docusign" {...a11yProps(3)} />
                                    <Tab label="Request Documents" {...a11yProps(4)} />
                                </Tabs>
                            </Box>
                            <CustomTabPanel value={value} index={0}>
                                <Overview data={loanData} setUserAction={setUserAction} />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={1}>
                                <Efolder data={efolderData} setUserAction={setUserAction} loanData={loanData} />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={2}>
                                <Other data={loanData} />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={3}>
                                <DocuSignPage data={params.id} />
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={4}>
                                <RequestDocuments loanId={params.id} borrowerEmail={loanData?.['1240']} loanNumber={loanData?.['364'] || ''} />
                            </CustomTabPanel>
                        </Box>
                    </Grid>

                    {/* Right Panel - Activity Timeline */}
                    <Grid item xs={12} md={5}>
                        <Box sx={{
                            position: 'sticky',
                            top: 16,
                            maxHeight: 'calc(100vh - 180px)',
                            overflow: 'hidden',
                        }}>
                            <LoanActivityTimeline
                                encompassLoanId={params.id}
                                borrowerName={`${loanData?.['4000'] || ''} ${loanData?.['4002'] || ''}`.trim()}
                                borrowerEmail={loanData?.['1240'] || ''}
                                borrowerPhone={loanData?.['66'] || ''}
                                setUserAction={setUserAction}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Container>

            {/* Loading Spinner */}
            {loading && (
                <Box sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    bgcolor: 'rgba(255,255,255,0.7)',
                    zIndex: 1300,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <CircularProgress />
                    <Typography variant="body2" sx={{ mt: 2 }}>
                        Loading data...
                    </Typography>
                </Box>
            )}
        </div>
    );
};

export default View;
